import { render, staticRenderFns } from "./GroupHeadTable.vue?vue&type=template&id=579e2054&scoped=true"
import script from "./GroupHeadTable.vue?vue&type=script&lang=js"
export * from "./GroupHeadTable.vue?vue&type=script&lang=js"
import style0 from "./GroupHeadTable.vue?vue&type=style&index=0&id=579e2054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e2054",
  null
  
)

export default component.exports